<template>
  <div class="goods_itr_box">
    <div class="qr_code">
      <div class="qr_togger" @mouseenter="onHover">手机购买<i class="qr_ico iconfont icon-ico" /></div>
      <div v-loading="loading" class="qr_pic">
        <img v-if="!loading" :src="base64Img">
      </div>
    </div>
    <el-tabs class="goods_itr my_tabs" type="border-card">
      <el-tab-pane label="商品介绍">
        <ul class="list">
          <li class="item">
            品牌：<span>{{goodsInfo.brandName}}</span>
          </li>
          <div class="item" v-if="currentMix.mixName">
            商品名称：<span>{{currentMix.mixName}}</span>
          </div>
          <div class="item" v-if="currentMix.mixNo">
            商品货号：<span>{{currentMix.mixNo}}</span>
          </div>
          <!-- <div class="item" v-if="goodsInfo.seriesName">
            商品系列：<span>{{goodsInfo.seriesName}}</span>
          </div> -->
          <div class="item" v-if="goodsInfo.colorTypeNo">
            供货商编号：<span>{{goodsInfo.colorTypeNo}}</span>
          </div>
          <div class="item" v-if="goodsInfo.styleName">
            商品风格：<span>{{goodsInfo.styleName}}</span>
          </div>
          <div class="item" v-if="goodsInfo.sendProvinceName">
            产地：<span>{{goodsInfo.sendProvinceName+" "+goodsInfo.sendCityName}}</span>
          </div>
          <div class="item" v-if="currentMix.mixGoodsLength && currentMix.mixGoodsWidth && currentMix.mixGoodsHeight">
            商品尺寸：<span>{{currentMix.mixGoodsLength+'mm*'+currentMix.mixGoodsWidth+'mm*'+currentMix.mixGoodsHeight+'mm'}}</span>
          </div>
          <!-- <div class="item" v-if="goodsInfo.materialName">
            商品材质：<span>{{goodsInfo.materialName}}</span>
          </div> -->
        </ul>
        <div class="adv"><img v-lazy="require('@/assets/img/goods_adv1.jpg')" alt=""></div>
        <div class="html_itr" v-html="goodsInfo.introduction"></div>
        <div class="adv"><img v-lazy="require('@/assets/img/goods_adv2.jpg')" alt=""></div>
        <div class="adv"><img v-lazy="require('@/assets/img/goods_adv3.jpg')" alt=""></div>
        <div class="adv"><img v-lazy="require('@/assets/img/goods_adv4.jpg')" alt=""></div>
        <div class="adv"><img v-lazy="require('@/assets/img/goods_adv5.jpg')" alt=""></div>
        <div class="adv"><img v-lazy="require('@/assets/img/goods_adv6.jpg')" alt=""></div>
        <div class="adv"><img v-lazy="require('@/assets/img/goods_adv7.jpg')" alt=""></div>
      </el-tab-pane>

      <el-tab-pane label="规格参数" v-if="classList.length>0">
        <div class="table">
          <dl class="attr_item" v-for="(item,index) in classList" :key="index">
            <dt class="title">{{item.className}}</dt>
            <div class="content">
              <dd class="item" v-for="(ele,num) in item.propList" :key="num">
                <div class="label">
                  <div class="name">
                    <span>{{ele.name+" :"}}</span>
                    <el-popover placement="right-start" width="200" trigger="hover" :content="ele.remark">
                      <span slot="reference" class="remake" v-if="ele.remark">
                        <i class="el-icon-question"></i>
                      </span>
                    </el-popover>
                  </div>
                </div>
                <div class="value">
                  <span v-for="(v,i) in ele.fieldValue" :key="i">
                    {{i==ele.fieldValue.length-1?v:v+'；'}}
                  </span>
                </div>
              </dd>
            </div>
          </dl>
        </div>
        <div class="adv"><img v-lazy="require('@/assets/img/goods_adv1.jpg')" alt=""></div>
        <div class="adv"><img v-lazy="require('@/assets/img/goods_adv2.jpg')" alt=""></div>
        <div class="adv"><img v-lazy="require('@/assets/img/goods_adv3.jpg')" alt=""></div>
        <div class="adv"><img v-lazy="require('@/assets/img/goods_adv4.jpg')" alt=""></div>
        <div class="adv"><img v-lazy="require('@/assets/img/goods_adv5.jpg')" alt=""></div>
        <div class="adv"><img v-lazy="require('@/assets/img/goods_adv6.jpg')" alt=""></div>
        <div class="adv"><img v-lazy="require('@/assets/img/goods_adv7.jpg')" alt=""></div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { GetMiniGoodsQrCode } from "@/pages/page1/api/modules/goods";
export default {
  props: {
    goodsInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    currentMix: {
      type: Object,
      default: () => {
        return {};
      },
    },
    classList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      base64Img: "",
      loading: false,
    };
  },
  methods: {
    onHover() {
      this.loading = true;
      this.getMiniGoodsQrCode(this.currentMix.serNo);
    },
    getMiniGoodsQrCode(serNo) {
      GetMiniGoodsQrCode({ serNo })
        .then((res) => {
          this.base64Img = res.data[0]
            ? "data:image/jpg;base64," + res.data[0]
            : "";
          // console.log("生成二维码", this.base64Img);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.goods_itr_box {
  position: relative;
  width: 100%;
  .qr_code {
    position: absolute;
    top: 0;
    right: 0;
    width: 160px;
    height: 39px;
    z-index: 2;
    cursor: pointer;
    .qr_togger {
      width: 100%;
      height: 100%;
      text-align: right;
      color: #989898;
      font-size: 12px;
      line-height: 39px;
      .qr_ico {
        padding: 0 20px 0 6px;
      }
    }
    .qr_pic {
      width: 140px;
      height: 140px;
      padding: 10px;
      display: block;
      overflow: hidden;
      background-color: #fff;
      display: none;
      /deep/ .el-loading-spinner {
        top: 50%;
      }
    }
    &:hover {
      .qr_togger {
        background: @themeColor;
        color: #fff;
      }
      .qr_pic {
        display: block;
      }
    }
  }
  .goods_itr {
    width: 100%;
    box-sizing: border-box;
    border: none;
    box-shadow: none;
    /deep/ .el-tabs__header {
      .el-tabs__item {
        padding: 0 30px !important;
        font-size: 16px;
      }
      .is-active {
        background: #ff9e00;
      }
    }
    /deep/ .el-tabs__content {
      padding: 30px 0 0 0;
      .el-tab-pane {
        color: #696969;
        font-size: 12px;
        .list {
          display: flex;
          flex-wrap: wrap;
          padding: 0 6px;
          margin-bottom: 50px;
          .item {
            min-width: 33%;
            box-sizing: border-box;
            padding: 10px 0 0 0;
          }
        }
        .html_itr {
          padding-top: 20px;
          height: auto;
          // font-size: 0;不能用这个 导致换行间距无用
          img {
            height: auto;
            width: auto;
            max-width: 100%;
            vertical-align: top; //img标签之间间隔3px 因为img是行内元素 换行导致
          }
        }
        .adv {
          img {
            width: 100%;
            height: auto;
          }
        }
        .table {
          margin-top: 40px;
          margin-bottom: 32px;
          width: 100%;
          box-sizing: border-box;
          border: 1px solid #dedede;
          background: #f4f4f4;
          color: #5b5b5b;
          .attr_item {
            border-bottom: 1px dashed #a9a9a9;
            line-height: 30px;
            &:last-child {
              border-bottom: none;
            }
            .title {
              float: left;
              width: 124px;
              padding-left: 22px;
              box-sizing: border-box;
              padding-top: 9px;
              font-weight: 500;
            }
            .content {
              margin-left: 124px;
              background: #ffffff;
              padding: 9px 0 9px 14px;
              .item {
                display: flex;
                .label {
                  min-width: 92px;
                  padding-right: 16px;
                  .name {
                    position: relative;
                    display: inline-block;
                  }
                  .remake {
                    position: absolute;
                    top: 0;
                    right: -16px;
                    color: #b3b5be;
                    font-size: 12px;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>